import { render, staticRenderFns } from "./pwdForm.vue?vue&type=template&id=30e2e57c&scoped=true&"
import script from "./pwdForm.vue?vue&type=script&lang=js&"
export * from "./pwdForm.vue?vue&type=script&lang=js&"
import style0 from "./pwdForm.vue?vue&type=style&index=0&id=30e2e57c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30e2e57c",
  null
  
)

export default component.exports